// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

const header = document.getElementById("__rptl-header");
const burgerState = document.getElementById("__rptl-header-burger-state");

document.addEventListener("click", (e) => {
  if (!header.contains(e.target)) {
    burgerState.checked = false;
  }
});

window.addEventListener("message", ({ source, data }) => {
  const iframes = document.getElementsByTagName("iframe");

  for (const iframe of iframes) {
    if (iframe.contentWindow === source) {
      iframe.style.height = `${data}px`;
      break;
    }
  }
});
